import curry from "./curry";

const log = (text, value) => {
  window.console.log(text, value);
  return value;
};

export default curry(log);
